import { computed, ref } from 'vue'

import { defineStore } from 'pinia'

import type { IAuthUser } from '@/apiClient/types/authUser'
import { useAuthTokens } from '@/composables/useAuthTokens'
import { keycloak } from '@/main'
import { checkAndDeleteCookieIfExpiringSoon } from '@/utils/cookies'

import { useAppStore } from '../app'

export const useAuthStore = defineStore('auth', () => {
  const { accessToken, refreshToken, idToken, sessionState } = useAuthTokens()

  const user = ref<IAuthUser>()
  const isAuthenticated = computed(
    () => !!user.value && useAppStore().isUserAuthorisedForEverGpt,
  )
  const isPlarformAdmin = computed(() => user.value?.role === 'ADMIN')

  const login = ({
    _accessToken,
    _refreshToken,
    _idToken,
    _sessionState,
  }: {
    _accessToken?: string
    _refreshToken?: string
    _idToken?: string
    _sessionState?: string
  }) => {
    if (_accessToken) accessToken.value = _accessToken
    if (_refreshToken) refreshToken.value = _refreshToken
    if (_idToken) idToken.value = _idToken
    if (_sessionState) sessionState.value = _sessionState
  }

  const setUser = (userData: IAuthUser) => {
    user.value = userData
  }

  const logout = (shouldSkipKeycloak?: boolean) => {
    if (!shouldSkipKeycloak) {
      keycloak.logout()
    }
    user.value = undefined
    accessToken.value = ''
    refreshToken.value = ''
    idToken.value = ''
    sessionState.value = ''
    // Check and delete welcome modal cookie if it's expiring soon
    checkAndDeleteCookieIfExpiringSoon('hasShownWelcomeModal')
  }

  // const isUpdatingSettings = ref(false)
  const updateUserSettings = () => {
    console.log('updateUserSettings')
    // if (!owuiUser.value || isUpdatingSettings.value) return Promise.resolve()
    // isUpdatingSettings.value = true

    // // Deep merge existing settings with new settings
    // const existingSettings = owuiUser.value.settings
    // const mergedSettings = deepMerge(existingSettings, settings)

    // return AuthApi.updateUserSettings(mergedSettings)
    //   .then((userSettings) => {
    //     if (!owuiUser.value) return
    //     owuiUser.value.settings = userSettings
    //   })
    //   .finally(() => {
    //     isUpdatingSettings.value = false
    //   })
  }

  // const stats = ref<IUnwrappedStats>()
  // const isLoadingStats = ref(false)
  // const statsPromise = ref<Promise<IUnwrappedStats>>()
  const fetchUnwrappedStats = async () => {
    console.log('TODO: fetchUnwrappedStats')
    // if (statsPromise.value || isLoadingStats.value || stats.value)
    //   return statsPromise.value

    // isLoadingStats.value = true
    // statsPromise.value = UnwrappedApi.getStats()
    //   .then((_stats) => {
    //     stats.value = _stats

    //     return _stats
    //   })
    //   .finally(() => {
    //     isLoadingStats.value = false
    //   })
  }

  return {
    // isUpdatingSettings,
    user,
    accessToken,
    refreshToken,
    idToken,
    sessionState,
    isAuthenticated,
    isPlarformAdmin,
    setUser,
    login,
    logout,
    updateUserSettings,

    // Unwrapped
    fetchUnwrappedStats,
  }
})
